import React from "react";
import { Card } from "../modules/HarvestsReports";

export function HarvestReportCardPage(props) {
  return <Card {...props} />;
}
